import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function StorySection() {
  return <section className="py-20 bg-white" data-id="element-123">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        {/* Opening Hook */}
        <div className="mb-16" data-id="element-125">
          <div className="border-l-4 border-brand-coral pl-6 py-2 mb-8 bg-brand-cream/50 rounded-r-xl p-6 shadow-sm" data-id="element-126">
            <p className="text-xl md:text-2xl font-heading text-brand-brown italic leading-relaxed" data-id="element-127">
              Son las 8:00 PM del domingo. Abres el refrigerador, te quedas
              mirando el estante vacío y suspiras. Otra vez la misma pregunta:{' '}
              <span className="font-bold text-brand-coral" data-id="element-128">
                "¿Qué les voy a poner de lunch mañana?"
              </span>
              .
            </p>
          </div>

          <p className="text-lg text-brand-brown/80 leading-relaxed mb-6" data-id="element-129">
            Sabes que terminarás enviando un sándwich aburrido o un paquete
            procesado porque el tiempo no te da para más. La culpa de no
            nutrirlos bien se mezcla con el agotamiento de una semana que ni
            siquiera ha empezado.
          </p>
        </div>

        {/* The Problem */}
        <div className="mb-16" data-id="element-130">
          <h2 className="text-3xl font-bold text-brand-brown mb-6" data-id="element-131">
            La carrera contra el reloj
          </h2>
          <p className="text-lg text-brand-brown/80 leading-relaxed mb-6" data-id="element-132">
            Vivir en Estados Unidos es correr contra el reloj. Los niños quieren
            comida que se parezca a la de sus amigos, las escuelas tienen reglas
            estrictas sobre el maní y tú solo quieres que coman algo que les
            recuerde a casa, pero que sea rápido.
          </p>
          <p className="text-lg text-brand-brown/80 leading-relaxed" data-id="element-133">
            Las recetas de Pinterest se ven hermosas, pero nadie tiene tiempo de
            cortar frutas en forma de estrella a las 6:30 AM mientras intentas
            vestirte para ir al trabajo. El resultado es estrés matutino,
            discusiones y loncheras que regresan a casa intactas porque "estaban
            feas" o "se enfriaron".
          </p>
        </div>

        {/* Failed Attempts */}
        <div data-id="element-134">
          <h3 className="text-2xl font-bold text-brand-brown mb-8 text-center" data-id="element-135">
            Por qué lo que has intentado no funciona:
          </h3>

          <div className="space-y-4" data-id="element-136">
            <div className="flex items-start gap-4 p-6 bg-brand-cream rounded-xl border border-brand-coral/10 shadow-sm" data-id="element-137">
              <XCircleIcon className="w-6 h-6 text-brand-coral flex-shrink-0 mt-1" data-id="element-138" />
              <p className="text-lg text-brand-brown/90" data-id="element-139">
                Las recetas de internet asumen que tienes ingredientes exóticos
                que no encuentras en tu Walmart local.
              </p>
            </div>

            <div className="flex items-start gap-4 p-6 bg-brand-cream rounded-xl border border-brand-coral/10 shadow-sm" data-id="element-140">
              <XCircleIcon className="w-6 h-6 text-brand-coral flex-shrink-0 mt-1" data-id="element-141" />
              <p className="text-lg text-brand-brown/90" data-id="element-142">
                Intentaste preparar todo el domingo, pero la comida perdió su
                textura y sabor para el miércoles.
              </p>
            </div>

            <div className="flex items-start gap-4 p-6 bg-brand-cream rounded-xl border border-brand-coral/10 shadow-sm" data-id="element-143">
              <XCircleIcon className="w-6 h-6 text-brand-coral flex-shrink-0 mt-1" data-id="element-144" />
              <p className="text-lg text-brand-brown/90" data-id="element-145">
                Sigues guías de nutrición aburridas que no entienden el paladar
                de un niño que ama las arepas, las empanadas o el arroz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}